import {LIST_FILE} from '../_actions/types'
export default function userReducer (state = {}, action: { type: any; payload: any; }) {
    switch (action.type) {
        case LIST_FILE:
            return { ...state, result: action.payload }
        default:
            return state;
    }
}